import type { CalibrationRecency } from '../../types';

export const formatCalibration = ({
    daysAgoSuffix,
    neverText,
    recency
}: {
    daysAgoSuffix: string;
    neverText: string;
    recency: CalibrationRecency;
}): string => (recency.recorded ? `${recency.daysAgo} ${daysAgoSuffix}` : neverText);
